<template>
  <div :id="appName" :class="[appCode, appName, theme]">
<!--    <nav>-->
<!--      &lt;!&ndash; recommended: absolute routes. you have to state the full path, but you're always sure where they go &ndash;&gt;-->
<!--      &lt;!&ndash; (of course, you should keep them in dedicated constants). &ndash;&gt;-->
<!--      &lt;!&ndash; only use relative routes when you need context dependent links &ndash;&gt;-->
<!--      <router-link :to="`/${appCode}/welcome`">{{ $t(`${appCode}:links.welcome`) }}</router-link>-->
<!--      &lt;!&ndash; even more recommended: named routes (to avoid stating the full path) &ndash;&gt;-->
<!--      <router-link :to="{ name: `${appCode}:about` }">{{ $t(`${appCode}:links.about`) }}</router-link>-->
<!--    </nav>-->
    <router-view :name="appCode" :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
import { Vuex, storeModuleTypes, environmentGetterTypes } from 'vue-infra';
import { appCode, appName } from '../config';
import './styles/app.scss';

const { mapGetters } = Vuex;

export default {
  name: appCode,
  computed: {
    ...mapGetters(storeModuleTypes.ENVIRONMENT, {
      currentActiveTheme: environmentGetterTypes.CURRENT_ACTIVE_THEME,
    }),
    theme() {
      return (this.currentActiveTheme && this.currentActiveTheme.keyName) || this.currentActiveTheme || 'dark';
    },
  },
  data() {
    return {
      appName,
      appCode,
    };
  },
};
</script>

<style lang="scss">
  .lp-le-management-console {
    position: relative;
    height: 100%;
    font-family: $font-family-Roboto, Arial;
    line-height: 135%;
    @include themify {
      color: getColor('text');
    }
  }
</style>
